module.exports = __webpack_public_path__ + "static/media/Sup-Res.759b3f69.png";